import {BaseClient} from '../utils/base-client';

class MessageVariantsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    const baseUrl = workspaceId ? `api/app/workspaces/${workspaceId}` : `api/app/projects/${projectId}`;
    return `${baseUrl}/messages/variants/`;
  }

  processResponse(response) {
    return response.results;
  }
}

export const messageVariantsClient = new MessageVariantsClient();
